import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { Organization } from '@/types/organization';

type UpdateExpirationMinutesArg = {
  expirationMinutes: number;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: UpdateExpirationMinutesArg }
): Promise<Organization> => {
  return await denApi.patch<Organization, UpdateExpirationMinutesArg>(
    'admin/organization/expiration-minutes',
    arg
  );
};

export function useUpdateExpirationMinutes(
  swrOptions?: SWRMutationConfiguration<
    Organization,
    Error,
    string,
    UpdateExpirationMinutesArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    Organization,
    Error,
    string,
    UpdateExpirationMinutesArg
  >('admin/organization/expiration-minutes', fetcher, swrOptions);

  return {
    updateExpirationMinutes: trigger,
    isLoading: isMutating,
    error,
  };
}
